"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "ClientDataType", {
  enumerable: !0,
  get: function get() {
    return _types.ClientDataType;
  }
}), Object.defineProperty(exports, "ConsentDataType", {
  enumerable: !0,
  get: function get() {
    return _types.ConsentDataType;
  }
}), Object.defineProperty(exports, "DataInfoType", {
  enumerable: !0,
  get: function get() {
    return _types.DataInfoType;
  }
}), Object.defineProperty(exports, "DataStorage", {
  enumerable: !0,
  get: function get() {
    return _storage.DataStorage;
  }
}), Object.defineProperty(exports, "FeatureFlagVariationsType", {
  enumerable: !0,
  get: function get() {
    return _types.FeatureFlagVariationsType;
  }
}), Object.defineProperty(exports, "IExternalStorage", {
  enumerable: !0,
  get: function get() {
    return _types.IExternalStorage;
  }
}), Object.defineProperty(exports, "IStorage", {
  enumerable: !0,
  get: function get() {
    return _types.IStorage;
  }
}), Object.defineProperty(exports, "IntegrityChecker", {
  enumerable: !0,
  get: function get() {
    return _integrityChecker.IntegrityChecker;
  }
}), Object.defineProperty(exports, "KameleoonStorageKey", {
  enumerable: !0,
  get: function get() {
    return _constants.KameleoonStorageKey;
  }
}), Object.defineProperty(exports, "StorageCleanupManager", {
  enumerable: !0,
  get: function get() {
    return _storageCleanupManager.StorageCleanupManager;
  }
}), Object.defineProperty(exports, "StorageDataType", {
  enumerable: !0,
  get: function get() {
    return _types.StorageDataType;
  }
}), Object.defineProperty(exports, "TrackingDataType", {
  enumerable: !0,
  get: function get() {
    return _types.TrackingDataType;
  }
}), Object.defineProperty(exports, "VISIT_DURATION", {
  enumerable: !0,
  get: function get() {
    return _constants.VISIT_DURATION;
  }
}), Object.defineProperty(exports, "VariationDataType", {
  enumerable: !0,
  get: function get() {
    return _types.VariationDataType;
  }
});
var _constants = require("./constants"),
  _storage = require("./storage"),
  _integrityChecker = require("./integrityChecker"),
  _storageCleanupManager = require("./storageCleanupManager"),
  _types = require("./types");